import React from 'react'

export default function POFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #po-footer-container {
          display: flex;
          justify-contents: center;
        }

        .translist-button-container {
          display: flex;
          justify-contents: center;
          padding: 5px;
        }

        #new-record-count-container {
          display: flex;
          flex: 3;
          font-size: 0.65em;
          justify-contents: center;
        }

        #new-record-count {
          border-radius: 3px;
          color: rgba(19, 19, 119, 1);
          padding: 0 7px;
          margin: auto 0;
          padding-bottom: 5px;
        }

        .notification {
          padding: 0 7px;
          padding-bottom: 5px;
          margin: auto 0;
        }
      `}
      </style>
    </React.Fragment>
  )
}
